/**
* @file 资源管理-司机资源-创建司机
* */
<template>
  <div class="createDriver">
    <!-- 步骤条 -->
    <el-steps :active="currentStep" finish-status="success" align-center class="driver-steps">
      <el-step title="账号设置" description="手机号、密码、头像"></el-step>
      <el-step title="证件信息" description="身份证、驾驶证、从业资格证"></el-step>
      <el-step title="确认提交" description="核对信息并提交"></el-step>
    </el-steps>

    <!-- Step 1: 账号设置 -->
    <div v-show="currentStep === 0">
      <el-form label-width="120px" label-position="left" :model="form" ref="formStep1" :rules="rulesStep1">
        <div class="formTitle">账号设置</div>
        <div style="display: flex; gap: 40px;">
          <div style="flex: 1; max-width: 440px;">
            <el-form-item label="机构名称" prop="organizationId">
              <el-select v-model="form.organizationId" filterable v-if="mixinUserInfo && mixinUserInfo.organizationType === 1" placeholder="请选择机构名称">
                <el-option v-for="(item, i) in organizations" :key="i" :value="item.id" :label="item.name"></el-option>
              </el-select>
              <span v-else>{{ organizations && organizations[0] && organizations[0].name }}</span>
            </el-form-item>
            <el-form-item label="手机号码" prop="phone">
              <el-input v-model="form.phone" placeholder="请输入11位手机号码" :maxlength="11"
                @input="onPhoneInput">
                <template slot="suffix">
                  <span v-if="form.phone && form.phone.length === 11 && /^1\d{10}$/.test(form.phone)"
                    style="color:#67C23A;font-size:16px">✓</span>
                  <span v-else-if="form.phone && form.phone.length > 0"
                    style="color:#F56C6C;font-size:12px">{{ form.phone.length }}/11</span>
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="登录密码" prop="password">
              <el-input v-model="form.password" placeholder="6-12位密码" :type="showPassword ? 'text' : 'password'" :maxlength="12">
                <i slot="suffix" :class="showPassword ? 'el-icon-view' : 'el-icon-remove-outline'"
                  style="cursor:pointer;line-height:32px;margin-right:4px" @click="showPassword = !showPassword"></i>
              </el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="confirmPassword">
              <el-input v-model="form.confirmPassword" placeholder="再次输入密码" :type="showConfirmPassword ? 'text' : 'password'" :maxlength="12">
                <i slot="suffix" :class="showConfirmPassword ? 'el-icon-view' : 'el-icon-remove-outline'"
                  style="cursor:pointer;line-height:32px;margin-right:4px" @click="showConfirmPassword = !showConfirmPassword"></i>
              </el-input>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="司机头像" prop="headPortrait">
              <up-img :file.sync="form.headPortrait" width="100" height="100"></up-img>
              <p class="field-tip">建议上传正面免冠照</p>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>

    <!-- Step 2: 证件信息 -->
    <div v-show="currentStep === 1">
      <el-form label-width="130px" label-position="left" :model="form" ref="formStep2" :rules="rulesStep2">
        <!-- 身份证信息 -->
        <div class="formTitle">
          身份证信息
          <span v-if="idCardIF" class="ocr-badge">支持 OCR 识别</span>
        </div>
        <div style="display: flex; gap: 40px;">
          <div style="flex: 1; max-width: 440px;">
            <el-form-item label="姓名" prop="name">
              <el-input v-model="form.name" placeholder="请输入真实姓名" :maxlength="12"></el-input>
            </el-form-item>
            <el-form-item label="身份证号" prop="idCard">
              <el-input v-model="form.idCard" placeholder="请输入18位身份证号" :maxlength="18"
                @input="onIdCardInput"></el-input>
            </el-form-item>
            <el-form-item label="性别">
              <span class="auto-field">
                {{ form.gender === 1 ? '男' : form.gender === 2 ? '女' : '—' }}
                <span v-if="form.gender" class="auto-field-tip">（由身份证号自动识别）</span>
              </span>
            </el-form-item>
            <el-form-item label="身份证有效期" prop="idCardValid" class="valid-item">
              <el-radio-group v-model="form.idCardValid" style="margin-right:12px">
                <el-radio :label="1">短期有效</el-radio>
                <el-radio :label="4102329600">长期有效</el-radio>
              </el-radio-group>
              <el-date-picker v-if="form.idCardValid !== 4102329600" v-model="form.idCardValidInput"
                type="date" placeholder="选择到期日期" :picker-options="pickerOptions1" style="width:160px">
              </el-date-picker>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="身份证人像页" prop="idCardFrontPath">
              <up-img :file.sync="form.idCardFrontPath" width="150" height="90"
                @change="onIdCardFrontChange"></up-img>
              <p class="field-tip">上传后自动识别姓名和证号</p>
            </el-form-item>
            <el-form-item label="身份证国徽页" prop="idCardBackPath">
              <up-img :file.sync="form.idCardBackPath" width="150" height="90"></up-img>
            </el-form-item>
          </div>
        </div>

        <!-- 驾驶证信息 -->
        <div class="formTitle">驾驶证信息</div>
        <div style="display: flex; gap: 40px;">
          <div style="flex: 1; max-width: 440px;">
            <el-form-item label="准驾车型" prop="driverClass">
              <el-select v-model="form.driverClass" placeholder="请选择准驾车型">
                <el-option v-for="item in $const.DRIVERSHORTTYPE" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="初次领证日期" prop="firstIssueDate">
              <el-date-picker v-model="form.firstIssueDate" type="date" placeholder="选择日期" :picker-options="pickerOptions"></el-date-picker>
            </el-form-item>
            <el-form-item label="驾驶证有效期" prop="driverLicenceValid" class="valid-item">
              <el-radio-group v-model="form.driverLicenceValid" style="margin-right:12px">
                <el-radio :label="1">短期有效</el-radio>
                <el-radio :label="4102329600">长期有效</el-radio>
              </el-radio-group>
              <el-date-picker v-if="form.driverLicenceValid !== 4102329600" v-model="form.driverLicenceValidInput"
                type="date" placeholder="选择到期日期" :picker-options="pickerOptions1" style="width:160px">
              </el-date-picker>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="驾驶证正页" prop="driverLicensePath">
              <up-img :file.sync="form.driverLicensePath" width="150" height="90"></up-img>
            </el-form-item>
            <el-form-item label="驾驶证副页" prop="driverLicenseBackPath">
              <up-img :file.sync="form.driverLicenseBackPath" width="150" height="90"></up-img>
            </el-form-item>
          </div>
        </div>

        <!-- 从业资格证 -->
        <div class="formTitle">从业资格证</div>
        <div style="display: flex; gap: 40px;">
          <div>
            <el-form-item label="证件照片" prop="qualificationsPath">
              <up-img :file.sync="form.qualificationsPath" width="150" height="90"></up-img>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>

    <!-- Step 3: 确认提交 -->
    <div v-show="currentStep === 2">
      <div class="formTitle">信息确认</div>
      <el-descriptions :column="2" border class="confirm-desc">
        <el-descriptions-item label="机构名称">{{ orgName }}</el-descriptions-item>
        <el-descriptions-item label="手机号码">{{ form.phone }}</el-descriptions-item>
        <el-descriptions-item label="司机姓名">{{ form.name }}</el-descriptions-item>
        <el-descriptions-item label="性别">{{ form.gender === 1 ? '男' : form.gender === 2 ? '女' : '—' }}</el-descriptions-item>
        <el-descriptions-item label="身份证号">{{ form.idCard }}</el-descriptions-item>
        <el-descriptions-item label="身份证有效期">{{ form.idCardValid === 4102329600 ? '长期有效' : form.idCardValidInput }}</el-descriptions-item>
        <el-descriptions-item label="准驾车型">{{ form.driverClass }}</el-descriptions-item>
        <el-descriptions-item label="初次领证日期">{{ form.firstIssueDate }}</el-descriptions-item>
        <el-descriptions-item label="驾驶证有效期">{{ form.driverLicenceValid === 4102329600 ? '长期有效' : form.driverLicenceValidInput }}</el-descriptions-item>
        <el-descriptions-item label="头像">
          <el-image v-if="form.headPortrait" :src="form.headPortrait" style="width:50px;height:50px;border-radius:4px"></el-image>
          <span v-else style="color:#999">未上传</span>
        </el-descriptions-item>
      </el-descriptions>
      <div class="form-tip" style="margin-top:16px;color:#909399;font-size:12px">
        <i class="el-icon-info"></i> 提交后证件信息不可修改，请仔细核对
      </div>
    </div>

    <!-- 底部操作按钮 -->
    <div class="form-button">
      <el-button v-if="currentStep > 0" @click="prevStep">上一步</el-button>
      <el-button v-if="currentStep < 2" type="primary" @click="nextStep">下一步</el-button>
      <el-button v-if="currentStep === 2" type="primary" @click="submitForm" :loading="loading">确认提交</el-button>
      <el-button @click="cancel">取消</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "createDriver",
  data() {
    const validateCheck = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.form.password) {
        callback(new Error("两次输入密码不一致"));
      } else {
        callback();
      }
    };
    return {
      currentStep: 0,
      showPassword: false,
      showConfirmPassword: false,
      form: {
        organizationId: null,
        phone: null,
        password: null,
        confirmPassword: null,
        headPortrait: null,
        name: null,
        idCard: null,
        idCardValid: 1,
        idCardValidInput: null,
        idCardFrontPath: null,
        idCardBackPath: null,
        gender: null,
        driverClass: null,
        firstIssueDate: null,
        driverLicenceValid: 1,
        driverLicenceValidInput: null,
        driverLicensePath: null,
        driverLicenseBackPath: null,
        qualificationsPath: null,
      },
      rulesStep1: {
        organizationId: [{ required: true, message: "请选择机构名称" }],
        phone: [
          { required: true, message: "请输入手机号码" },
          { pattern: /^1\d{10}$/, message: "请输入正确的11位手机号码" },
        ],
        password: [
          { required: true, message: "请输入登录密码" },
          { min: 6, max: 12, message: "密码长度为6-12位" },
        ],
        confirmPassword: [
          { required: true, message: "请输入确认密码" },
          { validator: validateCheck },
        ],
      },
      rulesStep2: {
        name: [
          { required: true, message: "请输入司机姓名" },
          { min: 2, max: 12, message: "姓名长度为2-12位" },
        ],
        idCard: [
          { required: true, message: "请输入身份证号" },
          { pattern: /(^\d{15}$)|(^\d{17}(\d|X|x)$)/, message: "请输入正确的身份证号（15或18位）" },
        ],
        idCardValid: [{ required: true, message: "请选择身份证有效期类型" }],
        idCardValidInput: [{ required: true, message: "请选择身份证到期日期" }],
        idCardFrontPath: [{ required: true, message: "请上传身份证人像页" }],
        idCardBackPath: [{ required: true, message: "请上传身份证国徽页" }],
        driverClass: [{ required: true, message: "请选择准驾车型" }],
        firstIssueDate: [{ required: true, message: "请选择初次领证日期" }],
        driverLicenceValid: [{ required: true, message: "请选择驾驶证有效期类型" }],
        driverLicenceValidInput: [{ required: true, message: "请选择驾驶证到期日期" }],
        driverLicensePath: [{ required: true, message: "请上传驾驶证正页" }],
        driverLicenseBackPath: [{ required: true, message: "请上传驾驶证副页" }],
        qualificationsPath: [{ required: true, message: "请上传从业资格证照片" }],
      },
      idCardIF: false,
      loading: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < new Date('1949-10-01').getTime() || time.getTime() > Date.now();
        },
      },
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 86400000;
        },
      },
    };
  },
  computed: {
    orgName() {
      const org = this.organizations && this.organizations.find(o => o.id === this.form.organizationId);
      return org ? org.name : (this.organizations && this.organizations[0] && this.organizations[0].name) || '';
    },
  },
  watch: {
    "form.idCard"(val) {
      if (val && (val.length === 15 || val.length === 18)) {
        this.form.gender = this.$utils.getGender(val) === "男" ? 1 : 2;
      }
    },
    "form.idCardFrontPath"(val, oldVal) {
      if (this.idCardIF && val && !oldVal) {
        this.ocrIdCard(val);
      }
    },
  },
  async created() {
    await this.mixinOrganizations();
    if (this.mixinUserInfo && this.mixinUserInfo.organizationType === 2 && this.organizations && this.organizations[0]) {
      this.$set(this.form, "organizationId", this.organizations[0].id);
    }
    const res = await this.$axios.get("/api/v1/manage/driver/queryIsOcr");
    if (res && res.code === 1) {
      this.idCardIF = res.data;
    }
  },
  methods: {
    cancel() {
      this.$router.go(-1);
    },
    onPhoneInput(val) {
      this.form.phone = val.replace(/\D/g, '').slice(0, 11);
    },
    onIdCardInput(val) {
      this.form.idCard = val.toUpperCase();
    },
    onIdCardFrontChange() {
      if (this.idCardIF && this.form.idCardFrontPath) {
        this.ocrIdCard(this.form.idCardFrontPath);
      }
    },
    async ocrIdCard(imgUrl) {
      try {
        const data = await this.$axios.post("/api/v1/manage/driver/ocr/idCard", { idCardImage: imgUrl });
        if (data && data.code === 1 && data.data) {
          if (data.data.idCard) this.form.idCard = data.data.idCard;
          if (data.data.name) this.form.name = data.data.name;
          this.$message.success("身份证识别成功，已自动填入信息");
        }
      } catch (e) {
        console.warn("[OCR识别失败]", e);
      }
    },
    nextStep() {
      const refName = `formStep${this.currentStep + 1}`;
      this.$refs[refName].validate((valid) => {
        if (valid) {
          if (this.currentStep === 1) {
            if (this.form.idCardValid !== 4102329600 && !this.form.idCardValidInput) {
              this.$message.warning("请选择身份证到期日期");
              return;
            }
            if (this.form.driverLicenceValid !== 4102329600 && !this.form.driverLicenceValidInput) {
              this.$message.warning("请选择驾驶证到期日期");
              return;
            }
          }
          this.currentStep++;
        } else {
          this.$message.warning("请完善当前步骤的必填信息");
        }
      });
    },
    prevStep() {
      this.currentStep--;
    },
    submitForm() {
      this.postFn();
    },
    async postFn() {
      this.loading = true;
      const url = "/api/v1/manage/driver";
      const params = {
        ...this.form,
        password: this.$utils.sha256Fn(this.form.password),
        idCardValid: this.form.idCardValid === 4102329600 ? this.form.idCardValid : Date.parse(new Date(this.form.idCardValidInput)) / 1000,
        driverLicenceValid: this.form.driverLicenceValid === 4102329600 ? this.form.driverLicenceValid : Date.parse(new Date(this.form.driverLicenceValidInput)) / 1000,
        firstIssueDate: Date.parse(new Date(this.form.firstIssueDate)) / 1000,
      };
      const { code } = await this.$axios.post(url, params);
      if (code === 1) {
        this.$message.success("司机创建成功！");
        this.$router.go(-1);
      }
      this.loading = false;
    },
  },
};
</script>

<style lang="less" scoped>
.createDriver {
  width: 100%;
  padding: 0 0 80px;
  position: relative;

  .driver-steps {
    padding: 20px 40px 30px;
    background: #fff;
    margin-bottom: 20px;
    border-radius: 4px;
  }

  .formTitle {
    font-size: 15px;
    font-weight: 600;
    color: #303133;
    padding: 16px 0 12px;
    border-bottom: 1px solid #EBEEF5;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    gap: 8px;

    .ocr-badge {
      font-size: 11px;
      font-weight: normal;
      background: #ecf5ff;
      color: #409EFF;
      border: 1px solid #b3d8ff;
      border-radius: 10px;
      padding: 1px 8px;
    }
  }

  .field-tip {
    margin: 4px 0 0;
    font-size: 11px;
    color: #909399;
    line-height: 1.4;
  }

  .auto-field {
    color: #303133;
    .auto-field-tip {
      color: #909399;
      font-size: 12px;
      margin-left: 4px;
    }
  }

  .valid-item {
    /deep/ .el-form-item__content {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 8px;
    }
  }

  .confirm-desc {
    margin-top: 16px;
    /deep/ .el-descriptions-item__label {
      width: 120px;
    }
  }

  .form-button {
    width: calc(100% - 200px);
    background: #fff;
    padding: 14px 20px;
    position: fixed;
    bottom: 0;
    right: 0;
    border-top: 1px solid #EBEEF5;
    display: flex;
    gap: 12px;
    z-index: 10;
  }
}
</style>
